var _defs, _path, _path2, _path3, _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVe = function SvgVe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "ve_svg__d",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ve_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ve_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ve_svg__a",
    fill: "#fff",
    d: "M0-5-1.5-.2l2.8.9z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__a",
    width: 180,
    height: 120,
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__b",
    width: 180,
    height: 120,
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__b",
    width: 180,
    height: 120,
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__c",
    width: 180,
    height: 120,
    transform: "rotate(144)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h640v320H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0h640v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ve_svg__f",
    transform: "matrix(4 0 0 4 320 336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ve_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__d",
    width: 180,
    height: 120,
    transform: "rotate(10)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__d",
    width: 180,
    height: 120,
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__e",
    width: 180,
    height: 120,
    transform: "rotate(40)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ve_svg__f",
    width: 180,
    height: 120,
    transform: "rotate(-80 320 336)"
  })));
};
export default SvgVe;